import { MyLabelWidgetComponent } from './label/label.widget';
import { MyTimeWidgetComponent } from './time/time.widget';
import { MyInputWidgetComponent } from './input/input.widget';
import { MyAvatarWidgetComponent } from './avatar/avatar.widget';
import { MyColumnWidgetComponent } from './column/column.widget';
import { MyFileWidgetComponent } from './file/file.widget';
import { MyPasswordWidgetComponent } from './password/password.widget';
import { MyEmailWidgetComponent } from './email/email.widget';
import { MyCustomWidgetComponent } from './custom/custom.widget';
import { MyTextAreaWidgetComponent } from './textarea/textarea.widget';
import { MyCheckboxWidgetComponent } from './checkbox/checkbox.widget';
import { MyRadioWidgetComponent } from './radio/radio.widget';
import { MySelectWidgetComponent } from './select/select.widget';
import { MySelectDynamicWidgetComponent } from './select-dynamic/select-dynamic.widget';
import { MyTableWidgetComponent } from './table/table.widget';
import { MyStringWidgetComponent } from './string/string.widget';
import { DefaultWidgetRegistry } from 'angular2-schema-form';
import { MyButtonWidgetComponent } from './button/button.widget';
import { MyIntegerWidgetComponent } from './integer/integer.widget';
import { MyDateWidgetComponent } from './date/date.widget';
import { MyFilterWidgetComponent } from './filter/filter.widget';

export class MyWidgetRegistry extends DefaultWidgetRegistry {
  constructor() {
    super();

    this.register('sf-string', MyStringWidgetComponent);
    this.register('sf-button', MyButtonWidgetComponent);
    this.register('sf-integer', MyIntegerWidgetComponent);
    this.register('sf-checkbox', MyCheckboxWidgetComponent);
    this.register('sf-radio', MyRadioWidgetComponent);
    this.register('sf-select', MySelectWidgetComponent);
    this.register('sf-select-dynamic', MySelectDynamicWidgetComponent);
    this.register('sf-table', MyTableWidgetComponent);
    this.register('sf-textarea', MyTextAreaWidgetComponent);
    this.register('sf-custom', MyCustomWidgetComponent);
    this.register('sf-email', MyEmailWidgetComponent);
    this.register('sf-password', MyPasswordWidgetComponent);
    this.register('sf-file', MyFileWidgetComponent);
    this.register('sf-column', MyColumnWidgetComponent);
    this.register('sf-avatar', MyAvatarWidgetComponent);
    this.register('sf-label', MyLabelWidgetComponent);
    this.register('sf-input', MyInputWidgetComponent);
    this.register('sf-time', MyTimeWidgetComponent);
    this.register('sf-date', MyDateWidgetComponent);
    this.register('sf-filter', MyFilterWidgetComponent);
    
  }
}



// WEBPACK FOOTER //
// ./src/shared/form-widgets/widget-registry.ts